import { BankAccount } from './company'
import { Country } from './country'
import { StatementLink } from './linker'

export const extractInvoice = (invoice: InvoiceQueryData): Invoice => {
  return {
    ...invoice,
    dueDate: new Date(invoice.dueDate),
    deliveryDate: invoice.deliveryDate ? new Date(invoice.deliveryDate) : undefined,
    issueDate: new Date(invoice.issueDate),
    paidAt: invoice.paidAt ? new Date(invoice.paidAt) : undefined,
    net: parseFloat(invoice.net),
    tax: parseFloat(invoice.tax),
    total: parseFloat(invoice.total),
    items: invoice.items.map(item => {
      return {
        ...item,
        quantity: parseFloat(item.quantity),
        price: parseFloat(item.price),
      }
    })
  }
}

type BaseInvoice = {
  id: string
  number: string
  createdBy: Owner
  note: string
  noteAlt: string
  internalNote: string
  paymentMethod: string
  currency: string
  invoiceMark: string
  cpName: string
  cpType: 'COMPANY' | 'PERSON'
  cpTaxId: string
  cpStreet: string
  cpCity: string
  cpPostalCode: string
  cpCountry: Country
  bankAccount: BankAccount
  paid: boolean
  paymentReference: string
  language: LanguageCode
  languageAlt?: LanguageCode | null
  // Only served on the detail query when statement_matching is on.
  statementLinks?: StatementLink[]
}

export interface Invoice extends BaseInvoice{
  deliveryDate?: Date
  dueDate: Date
  paidAt?: Date
  issueDate: Date
  net: number
  tax: number
  total: number
  items: InvoiceItem[]
}

export interface InvoiceQueryData extends BaseInvoice {
  deliveryDate: string
  dueDate: string
  paidAt: string | null
  issueDate: string
  net: string
  tax: string
  total: string
  items: Array<InvoiceItemQueryData>
}

type BaseInvoiceItem = {
  id: string
  description: string
  descriptionAlt: string
  taxRate: number
  discountPercentage: number
}

export interface InvoiceItem extends BaseInvoiceItem {
  quantity: number
  price: number
}

interface InvoiceItemQueryData extends BaseInvoiceItem {
  quantity: string
  price: string
}

type Owner = {
  fullName: string
  email: string
}

export type LanguageCode = 'HR' | 'EN'

export type Language = {
  code: LanguageCode
  name: string
  nativeName: string
}
